/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInner } from './GetProducts200ResponseItemsInner';
import {
    GetProducts200ResponseItemsInnerFromJSON,
    GetProducts200ResponseItemsInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerToJSON,
    GetProducts200ResponseItemsInnerToJSONTyped,
} from './GetProducts200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetProducts200Response
 */
export interface GetProducts200Response {
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInner>}
     * @memberof GetProducts200Response
     */
    items: Array<GetProducts200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetProducts200Response interface.
 */
export function instanceOfGetProducts200Response(value: object): value is GetProducts200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetProducts200ResponseFromJSON(json: any): GetProducts200Response {
    return GetProducts200ResponseFromJSONTyped(json, false);
}

export function GetProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetProducts200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetProducts200ResponseToJSON(json: any): GetProducts200Response {
    return GetProducts200ResponseToJSONTyped(json, false);
}

export function GetProducts200ResponseToJSONTyped(value?: GetProducts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetProducts200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

